import Icon from 'veui/components/Icon'

Icon.register({
  'scan-config': {
    paths: [
      {
        d: 'M696 576a120.15 120.15 0 00-1.69-20.12l33.81-29.59A158.55 158.55 0 00715.73 498l-2.23-3.88a160.72 160.72 0 00-18.43-25l-42.5 14.47a120 120 0 00-34.84-20.14l-8.72-44a161 161 0 00-66 0l-8.72 44a120 120 0 00-34.84 20.14l-42.5-14.47a160.8 160.8 0 00-18.43 25l-2.25 3.88a159 159 0 00-12.39 28.27l33.81 29.59a120.61 120.61 0 000 40.24l-33.81 29.59A158.86 158.86 0 00436.27 654l2.23 3.88a161.36 161.36 0 0018.43 25l42.5-14.47a120 120 0 0034.84 20.14l8.72 44a161 161 0 0066 0l8.72-44a120 120 0 0034.84-20.14l42.5 14.47a160.8 160.8 0 0018.43-25l2.23-3.86a159 159 0 0012.39-28.27l-33.81-29.59A120.15 120.15 0 00696 576zm-120 64a64 64 0 1164-64 64 64 0 01-64 64zm64-352a32 32 0 010 64H128a32 32 0 010-64zM448 96a32 32 0 0132-32h192a32 32 0 0132 32v96a32 32 0 01-64 0v-64H480a32 32 0 01-32-32zM320 672a32 32 0 01-32 32H96a32 32 0 01-32-32V448a32 32 0 0164 0v192h160a32 32 0 0132 32zM64 192V96a32 32 0 0132-32h192a32 32 0 010 64H128v64a32 32 0 01-64 0z'
      }
    ],
    width: '768',
    height: '768'
  }
})
